import api from './api';

/**
 * Download file from blob response
 */
const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Export tasks to specified format
 * @param {string} format - 'excel', 'csv', or 'pdf'
 * @param {object} filters - Optional filters (status, priority, projectId)
 */
export const exportTasks = async (format = 'excel', filters = {}) => {
  try {
    const params = new URLSearchParams({ format, ...filters });
    const response = await api.get(`/tasks/export?${params.toString()}`, {
      responseType: 'blob'
    });

    const extension = format === 'excel' ? 'xlsx' : format;
    const filename = `tasks_export_${new Date().getTime()}.${extension}`;
    downloadFile(response.data, filename);

    return { success: true, message: 'Tasks exported successfully' };
  } catch (error) {
    console.error('Error exporting tasks:', error);
    throw error;
  }
};

/**
 * Export issues to specified format
 * @param {string} format - 'excel', 'csv', or 'pdf'
 * @param {object} filters - Optional filters (status, severity, projectId)
 */
export const exportIssues = async (format = 'excel', filters = {}) => {
  try {
    const params = new URLSearchParams({ format, ...filters });
    const response = await api.get(`/issues/export?${params.toString()}`, {
      responseType: 'blob'
    });

    const extension = format === 'excel' ? 'xlsx' : format;
    const filename = `issues_export_${new Date().getTime()}.${extension}`;
    downloadFile(response.data, filename);

    return { success: true, message: 'Issues exported successfully' };
  } catch (error) {
    console.error('Error exporting issues:', error);
    throw error;
  }
};

/**
 * Export vendors to specified format
 * @param {string} format - 'excel', 'csv', or 'pdf'
 * @param {object} filters - Optional filters (status, category, search)
 */
export const exportVendors = async (format = 'excel', filters = {}) => {
  try {
    const params = new URLSearchParams({ format, ...filters });
    const response = await api.get(`/vendors/export?${params.toString()}`, {
      responseType: 'blob'
    });

    const extension = format === 'excel' ? 'xlsx' : format;
    const filename = `vendors_export_${new Date().getTime()}.${extension}`;
    downloadFile(response.data, filename);

    return { success: true, message: 'Vendors exported successfully' };
  } catch (error) {
    console.error('Error exporting vendors:', error);
    throw error;
  }
};

/**
 * Export vendor dashboard tasks to specified format
 * @param {string} format - 'excel', 'csv', or 'pdf'
 * @param {object} filters - Optional filters (status, priority, search)
 */
export const exportVendorDashboardTasks = async (format = 'excel', filters = {}) => {
  try {
    const params = new URLSearchParams({ format, ...filters });
    const response = await api.get(`/vendor-dashboard/tasks/export?${params.toString()}`, {
      responseType: 'blob'
    });

    const extension = format === 'excel' ? 'xlsx' : format;
    const filename = `vendor_tasks_${new Date().getTime()}.${extension}`;
    downloadFile(response.data, filename);

    return { success: true, message: 'Tasks exported successfully' };
  } catch (error) {
    console.error('Error exporting vendor tasks:', error);
    throw error;
  }
};

/**
 * Export vendor dashboard issues to specified format
 * @param {string} format - 'excel', 'csv', or 'pdf'
 * @param {object} filters - Optional filters (status, severity, search)
 */
export const exportVendorDashboardIssues = async (format = 'excel', filters = {}) => {
  try {
    const params = new URLSearchParams({ format, ...filters });
    const response = await api.get(`/vendor-dashboard/issues/export?${params.toString()}`, {
      responseType: 'blob'
    });

    const extension = format === 'excel' ? 'xlsx' : format;
    const filename = `vendor_issues_${new Date().getTime()}.${extension}`;
    downloadFile(response.data, filename);

    return { success: true, message: 'Issues exported successfully' };
  } catch (error) {
    console.error('Error exporting vendor issues:', error);
    throw error;
  }
};

/**
 * Export co-vendors to specified format
 * @param {string} format - 'excel', 'csv', or 'pdf'
 */
export const exportCoVendors = async (format = 'excel') => {
  try {
    const params = new URLSearchParams({ format });
    const response = await api.get(`/vendor-dashboard/co-vendors/export?${params.toString()}`, {
      responseType: 'blob'
    });

    const extension = format === 'excel' ? 'xlsx' : format;
    const filename = `co_vendors_${new Date().getTime()}.${extension}`;
    downloadFile(response.data, filename);

    return { success: true, message: 'Co-vendors exported successfully' };
  } catch (error) {
    console.error('Error exporting co-vendors:', error);
    throw error;
  }
};

const exportService = {
  exportTasks,
  exportIssues,
  exportVendors,
  exportVendorDashboardTasks,
  exportVendorDashboardIssues,
  exportCoVendors
};

export default exportService;


